var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _ButtonStyles = require("./ButtonStyles");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/Button/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Button = function (_React$Component) {
  (0, _inherits2.default)(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    (0, _classCallCheck2.default)(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderButton = function () {
      var _this$props = _this.props,
          title = _this$props.title,
          disabled = _this$props.disabled,
          alternative = _this$props.alternative,
          textColor = _this$props.textColor,
          customStyle = _this$props.customStyle,
          children = _this$props.children,
          regular = _this$props.regular,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["title", "disabled", "alternative", "textColor", "customStyle", "children", "regular"]);
      var buttonStyle = {};

      if (!customStyle) {
        buttonStyle = alternative ? _ButtonStyles.alternativeButtonStyle : _ButtonStyles.standardButtonStyle;
      }

      return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        center: true
      }, _objectSpread(_objectSpread({}, buttonStyle), rest), {
        style: {
          opacity: disabled ? 0.5 : 1
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 13
        }
      }), title ? _react.default.createElement(_Basic.Text, {
        bold: !regular,
        center: true,
        color: textColor || (alternative ? 'font.alternate' : 'highlight.secondary'),
        noSelect: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35,
          columnNumber: 21
        }
      }, title) : null, children);
    };

    return _this;
  }

  (0, _createClass2.default)(Button, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onPress = _this$props2.onPress,
          href = _this$props2.href,
          NavWrapper = _this$props2.NavWrapper;

      if (NavWrapper) {
        return _react.default.createElement(NavWrapper, {
          to: href,
          disabled: disabled,
          onClick: onPress,
          style: {
            textDecoration: 'none'
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56,
            columnNumber: 17
          }
        }, this.renderButton());
      }

      return href ? _react.default.createElement(_Basic.Clickable, {
        pointer: true,
        href: href,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68,
          columnNumber: 13
        }
      }, this.renderButton()) : _react.default.createElement(_Basic.View, {
        pointer: true,
        disabled: disabled,
        onClick: onPress,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 13
        }
      }, this.renderButton());
    }
  }]);
  return Button;
}(_react.default.Component);

Button.propTypes = {
  title: _propTypes.default.string,
  alternative: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onPress: _propTypes.default.func,
  NavWrapper: _propTypes.default.func
};
var _default = Button;
exports.default = _default;